// Contexto que el backend PHP deja en el DOM. Se lee de dos sitios:
//   - #datosGenerales: cabecera global del layout (block_mainCabecera.tpl).
//   - el div de montaje de la app, cuyo id cambia por app (#editorReact,
//     #reportsReact...) y lo genera reactBody() en PHP.
//
// `environment` es un singleton que se importa directamente (no se pasa por
// parametro). Cada app debe llamar a initEnvironment() ANTES de importar nada que
// lo lea: por eso los main.jsx arrancan con `import './environment'`.

const DEFAULTS = {
    nonPersonalizedAds: '0',
    files: '',
    resources: '',
    entorno: '',
    videos: '',
    entornoCookies: '',
    idUsuario: '',
    tokenID: '',
    super: '',
    anonymousToken: '',
    ai: true,
    screen: 'editor'
};

// Referencia estable: se rellena in situ para que quien ya lo haya importado vea los datos.
export const environment = { ...DEFAULTS };

export const initEnvironment = (mountId) => {
    const datosGenerales = document.getElementById('datosGenerales');
    const mount = document.getElementById(mountId);
    if (!mount) {
        throw new Error('No se encuentra el div de montaje #' + mountId);
    }

    Object.assign(environment, DEFAULTS);

    const params = new URLSearchParams(window.location.search)
    const keys = Object.keys(DEFAULTS);
    for (let i = 0; i < keys.length; i++) {
        if (datosGenerales) {
            let dato = datosGenerales.getAttribute('data-' + keys[i]);
            if (dato) {
                environment[keys[i]] = dato;
            }
        }
    }
    environment['lang'] = document.documentElement.getAttribute('lang');
    if (environment['lang'] == 'en') {
        environment['subdomain'] = 'www';
    } else {
        environment['subdomain'] = environment['lang'];
    }

    if (environment.resources.substring(0, 8) != 'https://') {
        environment['resources'] = 'https://' + environment.subdomain + '.' + environment.entorno + environment.resources;
    }
    environment['activity'] = mount.getAttribute('data-id');
    environment['transformid'] = mount.getAttribute('data-transformid');
    environment['screen'] = mount.getAttribute('data-screen');
    environment['rayAutostart'] = mount.getAttribute('data-rayAutostart') === '1';
    environment['rayJob'] = mount.getAttribute('data-rayJob');
    environment['openPreview'] = mount.getAttribute('data-openPreview') === '1';
    environment['guestsUrl'] = mount.getAttribute('data-guestsUrl') ?? '';
    environment['ownScores'] = mount.getAttribute('data-ownscores') === '1';
    environment['videos'] = environment.videos + "activities/" + environment['activity'] + "/";

    if (params.get('ai') == 'false') {
        environment['ai'] = false;
    }

    environment['isTemporalActivity'] = environment['activity']?.startsWith("T");

    return environment;
}
